import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.fehlerbild-entfernen';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenFehlerbildEntfernenEffects {

    FehlerbildEntfernen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_FEHLERBILD_ENTFERNEN),
        mergeMap((x: ac.PostFehlerbildEntfernenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postFehlerbildEntfernen(x.aufgabeBildRequest).pipe(
                map((result: any) => {
                    return new ac.PostFehlerbildEntfernenErfolgreichAction(x.aufgabeBildRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostFehlerbildEntfernenFehlerAction(error, x.aufgabeBildRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.FehlerCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.FehlerCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.FehlerCommandService);
        }
        return this.service;
    }
}
